//Сменить вариацию через селектор атрибутов
document.querySelectorAll('select.variations-selector').forEach(selector => {
    if (selector.closest('.variations')) return;

    //Устанавливаем у всех селекторов с этим атрибутом значение выбранного атрибута
    selector.addEventListener('change', () => {
        document.querySelector('.variations select.variations-selector[data-attribute_name="' + selector.dataset.attribute_name + '"]')
            .value = selector.value;

        //Тригерим проверку атрибутов и установку новой вариации
        jQuery(productForm).trigger('woocommerce_variation_select_change');
        jQuery(productForm).trigger('check_variations');
    });
});
//Действия при смене вариации
var current_variation = {};
(function () {
    let isFirstCall = true;

    jQuery(productForm).on('show_variation', (event, variation) => {
        //Глобально установить текущую вариацию
        current_variation = variation;

        //Изменить угол вариации
        jQuery(productForm).trigger('variation_corner_change', variation['corner']);

        if (!isFirstCall) {
            //Установить значения селекторов атрибутов вариации
            Object.keys(variation['attributes']).forEach(attribute => {
                document.querySelectorAll('select.variations-selector[data-attribute_name="' + attribute + '"]').forEach(selector => {
                    selector.value = variation['attributes'][attribute];
                });
            });

            //Установить url вариации
            const url = new URL(window.location.href);
            const searchParams = url.searchParams;
            Object.keys(variation['attributes']).forEach(attribute => {
                searchParams.set(attribute, variation['attributes'][attribute]);
            });
            url.search = searchParams.toString();
            window.history.replaceState({}, '', url.pathname + url.search);

            //Установить заголовок и описание на странице вариации
            document.querySelector('.product-title').innerHTML = variation['product_title_and_subtitle']['product_current_title'];
            document.querySelector('.product-scroll-line__title').innerHTML = variation['product_title_and_subtitle']['product_current_title'];

            let heroByeBtn = document.querySelector('.product-hero__add-to-cart');
            if (heroByeBtn) {
                heroByeBtn.dataset.product_id = variation['variation_id'];
            }

            let attributeLabelKey = Object.values(variation['attributes'])[0];
            let variationScrollLineAttrElem = document.querySelector('.product-scroll-line__size')
            if (variationScrollLineAttrElem) {
                variationScrollLineAttrElem.innerHTML = variation['attribute_labels'][attributeLabelKey];
            }

                //Установить title и desription на странице вариации
            document.title = variation['variation_meta']['title'];
            let metaDesc = document.querySelector('meta[name="description"]');
            if (metaDesc) {
                metaDesc.content = variation['variation_meta']['description'];
            }

            //Изменить title и alt при смене вариации
            if( document.querySelector('.slide.main>img') ){
                let current_main_image = document.querySelector('.slide.main>img');
                current_main_image.alt = variation['variation_image_tags']['main_alt']['title'];
                current_main_image.title = variation['title'] + ' размер ' + Object.values(variation['attribute_labels'])[1].replace(/\s/g, '') + ' см. Фото 1';
            }
            if( document.querySelector('.slide.second>img') ){
                let current_second_image = document.querySelector('.slide.second>img');
                current_second_image.alt = variation['variation_image_tags']['second_alt']['title'];
                current_second_image.title = variation['title'] + ' размер ' + Object.values(variation['attribute_labels'])[1].replace(/\s/g, '') + ' см. Фото 2';
            }

            //Установить артикул товара по всей странице
            document.querySelectorAll('.product-variation-sku').forEach(function (sku) {
                sku.innerHTML = variation['sku'];
            });

            //Установить заголовок вариации
            document.querySelectorAll('.product-variation-title').forEach(function (title) {
                title.innerHTML = variation['attribute_labels'][Object.values(variation['attributes'])[0]];
            });

            //Установить первое превью
            document.querySelectorAll('.product-variations-preview').forEach(function (preview) {
                if (preview.tagName === 'IMG') {
                    preview.src = variation['image']['full_src'];
                    preview.srcset = '';
                    preview.sizes = '';
                } else if (preview.tagName === 'DIV') {
                    preview.style.backgroundImage = 'url(' + variation['image']['full_src'] + ')';
                }
            });

            //Установить второе превью
            document.querySelectorAll('.product-variations-second-preview').forEach(function (preview) {
                if (preview.tagName === 'IMG') {
                    preview.src = variation['image']['secondPreviewFull'];
                    preview.srcset = '';
                    preview.sizes = '';
                } else if (preview.tagName === 'DIV') {
                    preview.style.backgroundImage = 'url(' + variation['image']['secondPreviewFull'] + ')';
                }
            });

            //Установить чертёж
            document.querySelectorAll('.product-variations-scheme').forEach(function (scheme) {
                scheme.src = variation['image']['scheme_src'];
                scheme.srcset = '';
                scheme.sizes = '';
            });

            //Установить габариты вариации
            document.querySelectorAll('.place-for-dimension').forEach(function (dimension) {
                dimension.innerHTML = variation['dimensions']['length'] + ' x ' + variation['dimensions']['width']
                    + ' x ' + variation['dimensions']['height'] + ' см';
            });

            //Установить вес вариации
            document.querySelectorAll('.place-for-dimension-weight').forEach(function (weight) {
                weight.innerHTML = variation['weight'] + ' кг';
            });

            //Установить размеры спального места вариации
            document.querySelectorAll('.size-of-sleeping-place').forEach(function (sleepingPlace) {
                sleepingPlace.innerHTML = variation['size-of-sleeping-place'] + ' см';
            });

            //Установить значение подушек для вариации товара
            document.querySelectorAll('.num-of-pillows').forEach(function (sleepingPlace) {
                sleepingPlace.innerHTML = variation['num-of-pillows'];
            });

            //Изменить кнопку скачать/получить 3D модель
            document.querySelectorAll('.get-tree-d-model').forEach(function (treeDModel) {
                if (variation['3D-model-link']) {
                    treeDModel.querySelector('span').innerHTML = '3D модель';
                    treeDModel.classList.remove('popmake-56287');
                    treeDModel.classList.remove('pum-trigger');
                    treeDModel.href = variation['3D-model-link'];
                    treeDModel.download = '';
                } else {
                    treeDModel.querySelector('span').innerHTML = 'Получить 3D модель';
                    treeDModel.classList.add('popmake-56287');
                    treeDModel.classList.add('pum-trigger');
                    treeDModel.removeAttribute('href');
                    treeDModel.removeAttribute('download');
                }
            });

            //Установить итоговую цену товара
            document.querySelectorAll('.total-price').forEach(function (totalPrice) {
                totalPrice.innerHTML = new Intl.NumberFormat('ru-RU').format(getProductTotalPrice()) + ' ₽';
            });

            //Обновить слайд Zarbo
            if (!document.body.classList.contains('product-template-new-product-page') && !updateZarboSlide()) {
                removeZarboSlide();
            }
        }

        //Сменить статус вызова этого коллбека
        isFirstCall = false;
    });
})();

//Тригер смены угла
jQuery(productForm).on('click', '.corner-trigger',  event => {
    event.stopPropagation();

    if (event.target.closest('.left')) {
        if (event.target.closest('.left').classList.contains('active')) return;

        jQuery(productForm).trigger('variation_corner_change', 'left');
    } else if (event.target.closest('.right')) {
        if (event.target.closest('.right').classList.contains('active')) return;

        jQuery(productForm).trigger('variation_corner_change', 'right');
    }
});
//Действия при смене угла
var current_variation_corner = '';
jQuery(productForm).on('variation_corner_change', (event, corner) => {
    current_variation_corner = corner;

    //Селектор угла вариаций
    const cornerSelector = document.querySelector('.corner-trigger');
    if (cornerSelector) {
        if (corner === 'left') {
            cornerSelector.classList.remove('hidden');

            cornerSelector.querySelector('.left').classList.add('active');
            cornerSelector.querySelector('.right').classList.remove('active');
        } else if (corner === 'right') {
            cornerSelector.classList.remove('hidden');

            cornerSelector.querySelector('.left').classList.remove('active');
            cornerSelector.querySelector('.right').classList.add('active');
        } else if (corner === '') {
            cornerSelector.classList.add('hidden');
        }
    }

    //Установить текст угла по всей странице
    document.querySelectorAll('.corner-text').forEach(function (cornerText) {
        if (corner === 'left') cornerText.innerHTML = ',&nbsp;левый';
        else if (corner === 'right') cornerText.innerHTML = ',&nbsp;правый';
        else if (corner === '') cornerText.innerHTML = '';
    });

    //Отзеркалить фото вариации по всей странице
    document.querySelectorAll('.variation-image-corner').forEach(function (image) {
        if (
            corner === ''
            || (current_variation['corner'] === 'left' && current_variation_corner === 'left')
            || (current_variation['corner'] === 'right' && current_variation_corner === 'right')
        ) {
            image.classList.remove('flip');
        } else if (
            (current_variation['corner'] === 'left' && current_variation_corner === 'right')
            || (current_variation['corner'] === 'right' && current_variation_corner === 'left')
        ) {
            image.classList.add('flip');
        }
    });

    //Изменить значение input
    const input = document.querySelector('.product-variations-sidebar input[name="po[corner]"]');
    if (input) {
        if (corner === 'left') {
            input.value = 'left';
            input.disabled = false;
        } else if (corner === 'right') {
            input.value = 'right';
            input.disabled = false;
        } else if (corner === '') {
            input.value = '';
            input.disabled = true;
        }
    }
});

//Действия при смене ткани
var current_fabric = {};
var current_fabric_color = {};
var current_fabric_category = {};
var current_fabric_texture = {};
var current_fabric_properties = {};
(function () {
    let isFirstCall = true;

    jQuery(productForm).on('fabric_changed', (event, fabric, color, category, texture, properties) => {
        //Глобально установить текущую ткань
        current_fabric = fabric;
        current_fabric_color = color;
        current_fabric_category = category;
        current_fabric_texture = texture;
        current_fabric_properties = properties;

        if (!isFirstCall) {
            //Установить значения input
            if (fabric['type'] === 'regular') {
                document.querySelector('input[name="po[fabric]"]').value = fabric['id'];
                document.querySelector('input[name="po[fabric]"]').disabled = false;
                document.querySelector('input[name="po[fabric-category]"]').disabled = true;
            } else if (fabric['type'] === 'catalog') {
                document.querySelector('input[name="po[fabric-category]"]').value = fabric['category_id'];
                document.querySelector('input[name="po[fabric]"]').disabled = true;
                document.querySelector('input[name="po[fabric-category]"]').disabled = false;
            }

            //Установить текстуру + название ткани
            document.querySelectorAll('.product-fabric-desc').forEach(fabricDesc => {
                fabricDesc.innerHTML = texture['name'] + ' ' + fabric['title'];
            });

            //Установить превью ткани
            document.querySelectorAll('.product-fabric-preview').forEach(preview => {
                preview.src = fabric['preview_url'] || '';
                preview.srcset = '';
                preview.sizes = '';
            });


            //Установить итоговую цену товара
            document.querySelectorAll('.total-price').forEach(function (totalPrice) {
                totalPrice.innerHTML = new Intl.NumberFormat('ru-RU').format(getProductTotalPrice()) + ' ₽';
            });

            //Обновить текстуру виджета
            if (!document.body.classList.contains('product-template-new-product-page')) {
                if (hasZarboWidget()) {
                    if (checkZarboWidgetCanBeUpdate('Ткань', fabric['sku'])) {
                        setZarboTexture('Ткань', fabric['sku']);
                    } else {
                        removeZarboSlide();
                    }
                } else {
                    updateZarboSlide();
                }
            }
        }

        //Сменить статус вызова этого коллбека
        isFirstCall = false;
    });
})();

//Действия при открытии основного сайдбара тканей
jQuery(document.body).on('fabric_main_sidebar_opened', () => {
    //Zarbo виджет на полный экран
    if (!document.body.classList.contains('product-template-new-product-page') && window.innerWidth >= 1290) {
        if (hasZarboWidget()) {
            openZarboWidgetModal();
        }
    }
});
//Действия при предварительном выборе ткани в основном сайдбаре ткани
jQuery(document.body).on('fabric_main_sidebar_preselect', (event, fabric) => {
    if (!document.body.classList.contains('product-template-new-product-page')) {
        if (window.innerWidth >= 1290) {
            if (hasZarboWidget()) {
                if (checkZarboWidgetCanBeUpdate('Ткань', fabric['sku'])) {
                    setZarboTexture('Ткань', fabric['sku']);
                    openZarboWidgetModal();
                } else {
                    closeZarboWidgetModal();
                }
            } else {
                if (updateZarboSlide()) {
                    setZarboTexture('Ткань', fabric['sku']);
                    openZarboWidgetModal();
                }
            }
        }
    }
});
//Действия при закрытии основного сайдбара тканей
jQuery(document.body).on('fabric_main_sidebar_closed', () => {
    //Zarbo виджет на полный экран
    if (!document.body.classList.contains('product-template-new-product-page') && window.innerWidth >= 1290) {
        if (checkZarboWidgetCanBeUpdate('Ткань', current_fabric['sku'])) {
            setZarboTexture('Ткань', current_fabric['sku']);
            closeZarboWidgetModal();
        } else {
            removeZarboSlide();
        }
    }
});

//Действия по нажатию чекбокса "Комбинирование тканей"
if (productForm) {
    if (document.querySelector('input[name="po[fabric-manager]"]')) {
        document.querySelector('input[name="po[fabric-manager]"]').addEventListener('change', function (event) {
            if (event.currentTarget.checked) {
                document.querySelector('.product-fabric__preview').style.opacity = '.3';
                document.querySelector('.product-fabric__desc').dataset.name = document.querySelector('.product-fabric__desc').innerText;
                document.querySelector('.product-fabric__desc').innerHTML = 'Выберу позже';
                document.querySelector('.fabric-main-sidebar input[name="po[fabric]"]').disabled = true;
                document.querySelector('.fabric-main-sidebar input[name="po[fabric-category]"]').disabled = true;
            } else {
                document.querySelector('.product-fabric__preview').style.opacity = '1';
                document.querySelector('.product-fabric__desc').innerText = current_fabric['title'];
                document.querySelector('.product-fabric__desc').dataset.name = current_fabric_texture['name'] + ' ' + current_fabric['title'];

                if (current_fabric['type'] === 'regular') {
                    document.querySelector('.fabric-main-sidebar input[name="po[fabric]"]').disabled = false;
                } else if (current_fabric['type'] === 'catalog') {
                    document.querySelector('.fabric-main-sidebar input[name="po[fabric-category]"]').disabled = false;
                }
            }
        });
    }
}

//Действия при смене опций
var current_options = [];
var current_options_variations = [];
var current_options_groups = [];
(function () {
    let isFirstCall = true;

    jQuery(productForm).on('options_changed', (event, variations, groups, options) => {
        //Глобально установить текущую опцию
        current_options = options;
        current_options_groups = groups;
        current_options_variations = variations;

        if (!isFirstCall) {
            //Установить значения input
            document.querySelectorAll('input[name^="po"]').forEach(input => {
                const variation = variations.find(variation => variation['id'] === Number(input.dataset.id));
                if (variation) {
                    if (input['type'] === 'number') {
                        input.value = variation['count'];
                        input.disabled = false;
                    } else {
                        input.checked = true;
                    }
                } else {
                    if (input['type'] === 'number') {
                        input.value = 0;
                        input.disabled = true;
                    } else {
                        input.checked = false;
                    }
                }
            });

            const product = productForm.classList.contains('variations_form')
                ? current_variation : JSON.parse(productForm.dataset.product);

            //Заменить информацию на плашке открытия сайдбара
            document.querySelectorAll('.options-trigger[data-group-id]').forEach(trigger => {
                const group = groups.find(group => group['id'] === Number(trigger.dataset.groupId));
                if (group) {
                    const _options = options.filter(option => option['group_id'] === group['id']);

                    const _variations = variations.filter(variation => variation['group_id'] === group['id']);
                    if (_variations.length) {
                        const infoWrapper = trigger.querySelector('.wrapper');
                        infoWrapper.innerHTML = '';

                        _variations.forEach(variation => {
                            let price = calcOptionPrice(product['display_price'], variation, variation['count']);
                            price = price ? new Intl.NumberFormat('ru-RU').format(price) + ' ₽' : 'бесплатно';

                            if (trigger.nodeName.toLowerCase() === 'a') {
                                if (_options.length === 1 && _options[0]['type'] === 'required') {
                                    const preview = trigger.querySelector('.preview');
                                    if (preview) preview.src = variation['preview_url'] || '';
                                }

                                const item = document.createElement('div');
                                item.classList.add('product-options-group__item');
                                infoWrapper.appendChild(item);

                                const title = document.createElement('span');
                                title.classList.add('product-options-group__item-title');
                                title.innerHTML = variation['count'] ? variation['title'] + ' x' + variation['count'] : variation['title'];
                                item.appendChild(title);

                                const itemPrice = document.createElement('span');
                                itemPrice.classList.add('product-options-group__item-price');
                                itemPrice.innerHTML = price;
                                item.appendChild(itemPrice);
                            } else if (trigger.nodeName.toLowerCase() === 'label') {
                                const item = document.createElement('div');
                                item.classList.add('product-options-group__item');
                                infoWrapper.appendChild(item);

                                const title = document.createElement('span');
                                title.classList.add('product-options-group__title');
                                title.innerHTML = group['title'];
                                item.appendChild(title);

                                const itemPrice = document.createElement('span');
                                itemPrice.classList.add('product-options-group__item-price');
                                itemPrice.classList.add('price');
                                itemPrice.innerHTML = price;
                                item.appendChild(itemPrice);
                            }
                        });
                    }
                } else {
                    if (trigger.nodeName.toLowerCase() === 'a') {
                        const infoWrapper = trigger.querySelector('.wrapper');
                        infoWrapper.innerHTML = '';
                    } else if (trigger.nodeName.toLowerCase() === 'label') {
                        trigger.querySelector('.price').innerHTML = '';
                    }
                }
            });

            //Сменить текстуру опции в виджете Zarbo
            if (!document.body.classList.contains('product-template-new-product-page')) {
                options.forEach(option => {
                    if ((option['type'] === 'single' || option['type'] === 'required') && option['zarbo']) {
                        const variation = variations.find(variation => variation['option_id'] === option['id']);
                        if (variation) {
                            if (hasZarboWidget()) {
                                if (checkZarboWidgetCanBeUpdate(option['zarbo'], variation['title'])) {
                                    setZarboTexture(option['zarbo'], variation['title']);
                                } else {
                                    removeZarboSlide();
                                }
                            } else {
                                updateZarboSlide();
                            }
                        }
                    }
                });
            }


            //Установить итоговую цену товара
            document.querySelectorAll('.total-price').forEach(function (totalPrice) {
                totalPrice.innerHTML = new Intl.NumberFormat('ru-RU').format(getProductTotalPrice()) + ' ₽';
            });
        }

        //Сменить статус вызова этого коллбека
        isFirstCall = false;
    });
})();
//Доля от цены по категории ткани (price-multiple), округлённая вверх до сотни
function calcFabricPrice(basePrice, category) {
    const price = basePrice * Number(category['price-multiple']);
    return Math.ceil(price / 100) * 100;
}

//Как считают сайдбары: без наценки — 0, даже если цена товара не число (calcFabricPrice() даст NaN)
function calcFabricPriceOrZero(basePrice, category) {
    return category['price-multiple'] ? calcFabricPrice(basePrice, category) : 0;
}

//Сумма в рублях или процент от цены («5%»), умноженная на количество, если оно не пустое и не 0
function calcOptionPrice(basePrice, optionVariation, count) {
    const price = String(optionVariation['price']);
    const unitPrice = price.endsWith('%') ? (parseInt(price) / 100) * basePrice : Number(price);
    return count ? unitPrice * count : unitPrice;
}

//Получить итоговую цену товара
function getProductTotalPrice() {
    //Цена товара/вариации
    const product = productForm.classList.contains('variations_form')
        ? current_variation : JSON.parse(productForm.dataset.product);

    let totalPrice = 0;
    totalPrice += product['display_price'];

    //Цена ткани
    const fabricObject = productForm.dataset.fabric_object ? JSON.parse(productForm.dataset.fabric_object) : {};
    if (Object.keys(fabricObject).length && Object.keys(current_fabric).length) {
        const currentFabricCategory = fabricObject['categories'].find(category => category['id'] === current_fabric['category_id']);
        totalPrice += calcFabricPrice(product['display_price'], currentFabricCategory);
    }

    //Опции товара
    current_options_variations.forEach(variation => {
        totalPrice += calcOptionPrice(product['display_price'], variation, variation['count']);
    });

    return totalPrice;
}

function hasZarboWidget() {
    return Boolean(document.querySelector('.product-gallery-main-slider .slide.zarbo iframe[name="zarbo"]'));
}

//Проверить может ли быть сформирован виджет со следующими данными
function checkZarboWidgetCanBeUpdate(shader, material) {
    if (!shader || !material) return false;

    //Объект товара/вариации
    let product = {};
    if (typeof current_variation === 'object' && Object.keys(current_variation).length) {
        product = current_variation;
    } else if (productForm && productForm.dataset.product) {
        product = JSON.parse(productForm.dataset.product);
    }
    if (typeof product !== 'object' || !Object.keys(product).length) return false;

    //Все шейдеры товара/вариации
    let allProductShaders = {};
    if (
        typeof product['zarbo'] === 'object' && Object.keys(product['zarbo']).length
        && typeof product['zarbo']['shaders'] === 'object' && Object.keys(product['zarbo']['shaders']).length
    ) {
        allProductShaders = product['zarbo']['shaders'];
    }
    if (typeof allProductShaders !== 'object' || !Object.keys(allProductShaders).length) return false;

    //Применяемые шейдеры
    const appliedShaders = {};
    appliedShaders[shader] = material;
    //Ткань
    if (
        !('Ткань' in appliedShaders)
        && typeof current_fabric === 'object' && Object.keys(current_fabric).length
    ) {
        appliedShaders['Ткань'] = current_fabric['sku'];
    }
    //Опции
    if (typeof current_options === 'object' && Object.keys(current_options).length) {
        for (let option of current_options) {
            if (
                !(option['zarbo'] in appliedShaders)
                && (option['type'] === 'single' || option['type'] === 'required')
                && option['zarbo']
            ) {
                const optionVariation = current_options_variations.find(optionVariation => optionVariation['option_id'] === option['id']);
                if (optionVariation) {
                    appliedShaders[option['zarbo']] = optionVariation['title'];
                }
            }
        }
    }
    if (!Object.keys(appliedShaders).length) return false;

    //Проверить есть ли у товара/вариации шейдер с такой текстурой
    for (let shader in appliedShaders) {
        if (shader in allProductShaders) {
            if (!allProductShaders[shader].includes(appliedShaders[shader])) return false;
        }
    }

    return true;
}

function updateZarboSlide() {
    //Объект товара/вариации
    let product = {};
    if (typeof current_variation === 'object' && Object.keys(current_variation).length) {
        product = current_variation;
    } else if (productForm && productForm.dataset.product) {
        product = JSON.parse(productForm.dataset.product);
    }
    if (typeof product !== 'object' || !Object.keys(product).length) return false;

    //Все шейдеры товара/вариации
    let allProductShaders = {};
    if (
        typeof product['zarbo'] === 'object' && Object.keys(product['zarbo']).length
        && typeof product['zarbo']['shaders'] === 'object' && Object.keys(product['zarbo']['shaders']).length
    ) {
        allProductShaders = product['zarbo']['shaders'];
    }
    if (typeof allProductShaders !== 'object' || !Object.keys(allProductShaders).length) return false;

    //Применяемые шейдеры
    const appliedShaders = {};
    //Ткань
    if (typeof current_fabric === 'object' && Object.keys(current_fabric).length) {
        appliedShaders['Ткань'] = current_fabric['sku'];
    }
    //Опции
    if (typeof current_options === 'object' && Object.keys(current_options).length) {
        for (let option of current_options) {
            if (
                (option['type'] === 'single' || option['type'] === 'required')
                && option['zarbo']
            ) {
                const optionVariation = current_options_variations.find(optionVariation => optionVariation['option_id'] === option['id']);
                if (optionVariation) {
                    appliedShaders[option['zarbo']] = optionVariation['title'];
                }
            }
        }
    }
    if (!Object.keys(appliedShaders).length) return false;

    //Формируем массивы параметров запроса
    const shaderCodes = [];
    const materialCodes = [];
    for (let shader in appliedShaders) {
        if (shader in allProductShaders) {
            if (allProductShaders[shader].includes(appliedShaders[shader])) {
                shaderCodes.push(shader);
                materialCodes.push(appliedShaders[shader]);
            } else {
                return false;
            }
        }
    }
    if (!shaderCodes.length || !materialCodes.length) return false;

    //Формируем параметры запроса
    const zarboQueryArgs = new URLSearchParams();
    zarboQueryArgs.set('shaderCodes', shaderCodes.join(', '));
    zarboQueryArgs.set('materialCode', materialCodes.join(', '));

    //Формируем ссылку
    const zarboURL = new URL('https://embed.zarbo.tech/' +  product['zarbo']['product_uuid'] + '/' + product['zarbo']['widget_id'] + '/');
    zarboURL.search = zarboQueryArgs;

    const thumbnailGallery = document.querySelector('.product-gallery-thumbnail-slider');
    const thumbnailGalleryWrapper = thumbnailGallery.querySelector('.wrapper');
    let thumbnailGallerySlideZarbo = thumbnailGalleryWrapper.querySelector('.slide.zarbo');

    const mainGallery = document.querySelector('.product-gallery-main-slider');
    const mainGalleryWrapper = mainGallery.querySelector('.wrapper');
    let mainGallerySlideZarbo = mainGalleryWrapper.querySelector('.slide.zarbo');

    //Заменить содержимое слайда Zarbo в галерее товара
    if (thumbnailGallerySlideZarbo && mainGallerySlideZarbo) {
        const thumbnailImage = thumbnailGallerySlideZarbo.querySelector('.image');
        if (thumbnailImage) {
            thumbnailImage.src = product['image']['full_src'];
            thumbnailImage.srcset = product['image']['srcset'];
            thumbnailImage.sizes = product['image']['sizes'];
        }

        mainGallerySlideZarbo.innerHTML = '';

        //Прокрутить слайдер до слайда с Zarbo
        isAllowSwitchToZarboSlide = true;
        const indexSlideZarbo = Array.from(mainGalleryWrapper.children).indexOf(mainGallerySlideZarbo);
        mainGallery.swiper.slideTo(indexSlideZarbo);
    }
    //Вставить слайд Zarbo в галерею товара
    else {
        thumbnailGallerySlideZarbo = document.createElement('div');
        thumbnailGallerySlideZarbo.classList.add('product-gallery-thumbnail-slider__slide');
        thumbnailGallerySlideZarbo.classList.add('slide');
        thumbnailGallerySlideZarbo.classList.add('zarbo');
        thumbnailGalleryWrapper.insertBefore(thumbnailGallerySlideZarbo, thumbnailGalleryWrapper.firstChild);

        const thumbnailImage = document.createElement('img');
        thumbnailImage.classList.add('product-gallery-thumbnail-slider__image');
        thumbnailImage.classList.add('image');
        thumbnailImage.src = product['image']['full_src'];
        thumbnailImage.srcset = product['image']['srcset'];
        thumbnailImage.sizes = product['image']['sizes'];
        thumbnailGallerySlideZarbo.appendChild(thumbnailImage);

        const ar = document.createElement('div');
        ar.classList.add('product-gallery-thumbnail-slider__ar');
        ar.innerHTML = 'AR';
        thumbnailGallerySlideZarbo.appendChild(ar);

        mainGallerySlideZarbo = document.createElement('div');
        mainGallerySlideZarbo.classList.add('product-gallery-main-slider__slide');
        mainGallerySlideZarbo.classList.add('slide');
        mainGallerySlideZarbo.classList.add('zarbo');
        mainGalleryWrapper.insertBefore(mainGallerySlideZarbo, mainGalleryWrapper.firstChild);

        thumbnailGallery.swiper.update();
        mainGallery.swiper.update();

        //Прокрутить слайдер до слайда с Zarbo
        isAllowSwitchToZarboSlide = true;
        const indexSlideZarbo = Array.from(mainGalleryWrapper.children).indexOf(mainGallerySlideZarbo);
        mainGallery.swiper.slideTo(indexSlideZarbo);
    }

    const frame = document.createElement('iframe');
    frame.name = 'zarbo';
    frame.src = zarboURL.toString();
    frame.loading = 'eagr';
    frame.allow = 'camera; autoplay; xr-spatial-tracking';
    frame.allowfullscreen = '';
    frame.frameBorder = 0;
    mainGallerySlideZarbo.appendChild(frame);

    return true;
}

function removeZarboSlide() {
    const thumbnailGallery = document.querySelector('.product-gallery-thumbnail-slider');
    const thumbnailGallerySlideZarbo = thumbnailGallery.querySelector('.slide.zarbo');

    const mainGallery = document.querySelector('.product-gallery-main-slider');
    const mainGallerySlideZarbo = mainGallery.querySelector('.slide.zarbo');
    if (thumbnailGallerySlideZarbo && mainGallerySlideZarbo) {
        const isNeedCorrectSliderPosition = !mainGallerySlideZarbo.classList.contains('swiper-slide-active');
        const currentIndex = mainGallery.swiper.activeIndex;

        thumbnailGallerySlideZarbo.remove();
        mainGallerySlideZarbo.remove();

        thumbnailGallery.swiper.update();
        mainGallery.swiper.update();

        //Если выбран не Zarbo слайд, то прокрутить слайдер
        if (isNeedCorrectSliderPosition) mainGallery.swiper.slideTo(currentIndex - 1, 0);
    }
}

function setZarboTexture(shaderCode, materialCode) {
    window.frames.zarbo.postMessage({
        'type': 'change-material',
        'codename': materialCode
    }, '*');
}

function openZarboWidgetModal() {
    const mainGallery = document.querySelector('.product-gallery-main-slider');
    const mainGalleryWrapper = mainGallery.querySelector('.wrapper');
    const mainGallerySlideZarbo = mainGalleryWrapper.querySelector('.slide.zarbo');
    if (mainGallerySlideZarbo) {
        const widget = mainGallerySlideZarbo.querySelector('iframe[name="zarbo"]');
        widget.classList.add('full-screen');

        isAllowSwitchToZarboSlide = true;
        mainGallery.swiper.slideTo(0, 0);
        mainGalleryWrapper.style.transform = '';
        mainGallery.swiper.disable();
    }
}
function closeZarboWidgetModal() {
    const mainGallery = document.querySelector('.product-gallery-main-slider');
    const mainGalleryWrapper = mainGallery.querySelector('.wrapper');
    const mainGallerySlideZarbo = mainGalleryWrapper.querySelector('.slide.zarbo');
    if (mainGallerySlideZarbo) {
        const widget = mainGallerySlideZarbo.querySelector('iframe[name="zarbo"]');
        widget.classList.remove('full-screen');

        mainGallery.swiper.enable();
    }
}
